<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-medication`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M28.243 4.201l15.556 15.556a6 6 0 010 8.486L28.243 43.799a6 6 0 01-8.486 0L4.201 28.243a6 6 0 010-8.486L19.757 4.201a6 6 0 018.486 0zm-5.657 2.828L7.029 22.586a2 2 0 000 2.828l15.557 15.557a2 2 0 002.828 0L40.97 25.414a2 2 0 000-2.828L25.415 7.029a2 2 0 00-2.828 0zM26 15a1 1 0 00-1-1h-2a1 1 0 00-1 1v7h-7a1 1 0 00-1 1v2a1 1 0 001 1h7v7a1 1 0 001 1h2a1 1 0 001-1v-7h7a1 1 0 001-1v-2a1 1 0 00-1-1h-7v-7z"/></svg>
</template>
<script>

export default {
  name: 'IconMedication',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
